var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext, useEffect, useState } from "preact/hooks";
import { SoaContext } from "./provider";
import { metadataOf } from "./metadata";
export function useService(target) {
    var container = useContext(SoaContext);
    var meta = metadataOf(target.prototype);
    return container ? container.services[meta.id] : null;
}
export function trackService(target) {
    useObserver([target]);
    var container = useContext(SoaContext);
    var meta = metadataOf(target.prototype);
    return container ? container.services[meta.id] : null;
}
export function useObserver(types) {
    var container = useContext(SoaContext);
    var updater = useState({});
    useEffect(function () {
        var released = false;
        var releaseQueue = [];
        if (types && types.length > 0) {
            types.forEach(function (typ) {
                var id = metadataOf(typ.prototype).id;
                var channel = metadataOf(container.services[id]).channel;
                var listener = channel.listen(function (variable, value) {
                    if (released)
                        return;
                    var key = id + variable;
                    updater[1](function (state) {
                        var _a;
                        if (typeof state[key] === 'undefined' || state[key] !== value) {
                            return __assign(__assign({}, state), (_a = {}, _a[key] = value, _a));
                        }
                        else {
                            return state;
                        }
                    });
                });
                releaseQueue.push(listener);
            });
        }
        return function () {
            released = true;
            releaseQueue.forEach(function (func) { return func(); });
        };
    }, []);
}
